import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  getImages: {
    method: 'GET',
    url: `${configs.baseUrl}/api/uploaded/images`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const getImages = async (params) => {
  return resource.getImages(params)
}

export default {
  initResource,
  getImages,
}
